"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instance = exports.instanceSettings = void 0;
function instanceSettings(settings) {
    return function instanceSettingsDecorator(constructor) {
        constructor.prototype.settings = settings;
    };
}
exports.instanceSettings = instanceSettings;
class Instance {
    setInstances(instances) {
        this.instances = instances;
    }
    setContext(context) {
        this.context = context;
    }
}
exports.Instance = Instance;
//# sourceMappingURL=Instance.js.map